// @ts-ignore
import HLayout from "./src/index.vue";
export default HLayout;
export * from "./src/type";